const labels = {
  QrCode: {
    'Ref: Page title': 'MyBus',
    'Ref: Hi': 'היי',
    'Ref: Page content body': 'עם ההגעה והיציאה אנא הקפד לזכור לסרוק את אוטובוס קוד ה- QR שלך',
  },
};
export default labels;
